import type { EquipmentV2SettingsType } from "../reducers/EquipmentV2SettingsReducer";

export const EQUIPMENT_V2_SETTINGS_INIT = "equipmentV2Settings/init";

type InitEquipmentV2SettingsType = {
    type: typeof EQUIPMENT_V2_SETTINGS_INIT;
    initState: EquipmentV2SettingsType;
};

export const initEquipmentV2Settings = (initState: EquipmentV2SettingsType): InitEquipmentV2SettingsType => ({
    type: EQUIPMENT_V2_SETTINGS_INIT,
    initState,
});

export type EquipmentV2SettingsActionsType = InitEquipmentV2SettingsType;
